<div class="d-flex flex-wrap align-content-flex-start surface-high-contrast cashin-container">
  <ngx-app-bar
    class="w-100"
    [title]="'ورود اطلاعات'"
    [rightButton]="{
      icon: 'arrow-right',
      style: 'neutral-link',
      mode: 'icon-only',
      size: 'medium',
    }"
    (onRightButtonClick)="onBackHandler()"
  />

  <div class="w-100 mt-big content-container px-plus">
    <p>تاریخ تولد مالک شماره {{ state().phoneNumber }} را وارد کنید.</p>

    <div class="w-100 mt-big">
      <ui-form-field
        [customDateRange]="customDateRange()"
        [errorMessageMapper]="{
          required: 'تاریخ تولد را انتخاب کنید.',
          invalidBirthDay: serverErrorMessage(),
        }"
        [error]="birthDayController.errors"
        [type]="'date'"
        [dateRange]="'past'"
        [formControl]="birthDayController"
        [label]="'تاریخ تولد'"
        [datePickerMode]="'bottomSheet'"
      ></ui-form-field>
    </div>
  </div>

  <div class="w-100 button-container px-plus">
    <ngx-button
      [buttonId]="'WALLET_CONFIRM_BIRTHDAY'"
      [style]="'fill'"
      [fullWidth]="true"
      [mode]="'form'"
      size="medium"
      [disabled]="birthDayController.invalid"
      [isLoading]="isLoading()"
      (clickHandler)="continue()"
    >
      تایید و ادامه
    </ngx-button>
  </div>
</div>
